import { FC } from 'react';

import { ICON_STROKE_WIDTH } from 'views/components/UI/Icons/icons.constants';
import { IIconProps } from 'views/components/UI/Icons/icons.interface';

const PriorityUnset: FC<IIconProps> = ({
  size = '16',
  color = 'var(--sk-icon-subtle)',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="8"
      cy="8"
      r="5"
      stroke={color}
      strokeWidth={ICON_STROKE_WIDTH}
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);

export { PriorityUnset };
